import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  Output,
} from '@angular/core'

export interface ResizableEvent {
  width: number
  height: number
}

@Directive({
  selector: '[hsResizable]',
})
export class ResizableDirective implements AfterViewInit, OnDestroy {
  @Input() hsResizable: string | undefined = undefined
  @Output() resizeChanged = new EventEmitter<ResizableEvent>()

  /** @internal */
  containerElement?: HTMLElement
  /** @internal */
  handleElement?: HTMLElement
  /** @internal */
  previousResizeEvent?: ResizableEvent
  /** @internal */
  isMouseDown = false
  /** @internal */
  didDrag = false

  constructor(public element: ElementRef) {}

  ngOnDestroy(): void {
    if (this.containerElement) {
      this.containerElement.classList.remove('hs-resizable')
    }
  }

  ngAfterViewInit() {
    let element: HTMLElement = this.element.nativeElement

    // This is the handle element, by default, the element is the handle element
    this.handleElement = this.element.nativeElement

    if (!this.handleElement) {
      return
    }

    if (this.hsResizable) {
      while (element.parentElement) {
        element = element.parentElement
        if (element?.classList.contains(this.hsResizable)) {
          break
        }
      }
    }

    this.containerElement = element

    this.containerElement.classList.add('hs-resizable')

    /* 
    Forcefully increasing the height or width of the component to trigger the, 
    resize event and to achieve dynamic resize of table with the size of the modal
    */
    // Increase the width or height by 1 pixel
    if (this.containerElement) {
      this.containerElement.style.height = `${
        this.containerElement.offsetHeight + 1
      }px`
      // or for width
      // this.containerElement.style.width = `${this.containerElement.offsetWidth + 1}px`;

      // After resizing, trigger onResize to emit the changed size
      this.onResize()
    }
  }

  onResize() {
    if (
      this.previousResizeEvent?.width === this.containerElement?.offsetWidth ||
      this.previousResizeEvent?.height === this.containerElement?.offsetHeight
    ) {
      return
    }
    this.previousResizeEvent = {
      width: this.containerElement?.offsetWidth ?? 0,
      height: this.containerElement?.offsetHeight ?? 0,
    }
    this.resizeChanged.emit(this.previousResizeEvent)
  }

  /**
   * Apparently, Internet explorer was the only on who implemented onresize on the element, weird enough.
   */
  @HostListener('document:mouseup', ['$event'])
  onMouseUp() {
    if (this.isMouseDown && this.didDrag) {
      this.onResize()
    }
    this.isMouseDown = false
    this.didDrag = false
  }

  @HostListener('document:mousedown', ['$event'])
  onMouseDown() {
    this.isMouseDown = true
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove() {
    if (!this.isMouseDown) {
      return
    }
    this.didDrag = true
  }
}
